export default __webpack_public_path__ + "static/B0251-0f389f3d996f1a03ab994267820a5790.png";